export class VehicleLookupResponse {
    constructor(response, registrationNumber) {
        if (!response) {
            throw new Error("Missing vehicle lookup response data");
        }
        this.response = response;
        this.registrationNumber = registrationNumber;
    }
    getVehicle() {
        return {
            manufacturer: this.response.manufacturer,
            modelName: this.response.modelName,
            modelSeries: this.response.modelSeries,
            modelYear: this.response.modelYear,
            valuation: this.response.valuation,
        };
    }
}
